  <template>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <v-container fluid>
            <v-card-title>

              <v-spacer/>
              تاریخچه تماس
              <v-spacer/>
<!--              <v-btn :loading="loading" @click="this.fetchIndexData" class="btn-update">-->
<!--                <v-icon>mdi-refresh</v-icon>-->
<!--                به روزرسانی-->
<!--              </v-btn>-->

            </v-card-title>
            <v-divider/>

            <div class="row">

              <div class="col-md-12 p-5">

                <data-table
                    orderDir="desc"
                    :data="data"
                    :columns="columnTransactions"
                    :translate="translates"
                    :per-page="perPages"
                    @on-table-props-changed="reloadTable">
                </data-table>
              </div>
            </div>

          </v-container>
        </div>
      </div>
    </div>

  </template>

  <script>
    export default {
      name: "VoipHistory",
      data() {
        return  {
          data:{},
          tableProps: {
            search: '',
            length: 10,
            column: 'id',
            dir: 'desc',
          },
          loading: false,
          columnTransactions: [
            {
              name: 'id',
              label: 'شناسه',
              orderable: true,
            },
            {
              name: 'number',
              label: 'شماره',
              orderable: true,
            },
            {
              name: 'call_time',
              label: 'مدت زمان صحبت',
              orderable: true,
            },
            {
              name: 'call_date',
              label: 'تاریخ تماس',
              orderable: true,
            },
            {
              name: 'call_time',
              label: 'ساعت تماس',
              orderable: true,
            },
            {
              name: 'actions',
              label: 'عملیات',
              orderable: true,
            },

          ],


        }
      },
      methods: {
        fetchIndexData() {

        },
        reloadTable() {

        }
      }
    }
  </script>

  <style scoped>

  </style>
